import {
  Order,
  OrderPaymentCard,
  OrderPaymentInstallmentDetails,
  PaymentMethod,
  PaymentStatus,
} from '../../../../models/order.model';
import { getDefaultPaymentCard, getDownPayment } from './order-details.util';

export interface PaymentAttempt {
  date: Date;
  method: string;
  card: OrderPaymentCard | null;
  providerPaymentId: string;
  status: string;
  statusTag: string;
  amount: number;
}

function describeMethod(method: PaymentMethod): string {
  switch (method) {
    case PaymentMethod.CreditCard:
      return 'Crédito';
    case PaymentMethod.DebitCard:
      return 'Débito';
    case PaymentMethod.BankTransfer:
      return 'Transferência';
    case PaymentMethod.BankSlip:
      return 'Boleto';
    default:
      return '-';
  }
}

function describeStatus(status: PaymentStatus): string {
  switch (status) {
    case PaymentStatus.Pending:
      return 'Pendente';
    case PaymentStatus.Processing:
      return 'Processando';
    case PaymentStatus.Confirmed:
      return 'Confirmado';
    case PaymentStatus.Failed:
      return 'Falhou';
    case PaymentStatus.Refunded:
      return 'Estornado';
    case PaymentStatus.Cancelled:
      return 'Cancelado';
    default:
      return '-';
  }
}

export function getPaymentStatusTag(status: PaymentStatus): string {
  switch (status) {
    case PaymentStatus.Confirmed:
      return 'Confirmed';
    case PaymentStatus.Processing:
      return 'InProgress';
    case PaymentStatus.Failed:
      return 'Rejected';
    case PaymentStatus.Refunded:
      return 'Draft';
    case PaymentStatus.Cancelled:
      return 'Cancelled';
    default:
      return 'Pending';
  }
}

function cardOf(method: PaymentMethod, order: Order | null) {
  const isCard =
    method === PaymentMethod.CreditCard || method === PaymentMethod.DebitCard;

  return isCard ? getDefaultPaymentCard(order) : null;
}

/** Most recent first. */
export function mapPaymentAttempts(
  payments: OrderPaymentInstallmentDetails[],
  order: Order | null,
): PaymentAttempt[] {
  return [...payments]
    .sort(
      (a, b) =>
        new Date(b.confirmedAt).getTime() - new Date(a.confirmedAt).getTime(),
    )
    .map((payment) => ({
      date: payment.confirmedAt,
      method: describeMethod(payment.method),
      card: cardOf(payment.method, order),
      providerPaymentId: payment.providerPaymentId,
      status: describeStatus(payment.status),
      statusTag: getPaymentStatusTag(payment.status),
      amount: payment.amount,
    }));
}

export function getDownPaymentAttempts(order: Order | null): PaymentAttempt[] {
  return mapPaymentAttempts(getDownPayment(order)?.payments ?? [], order);
}
